<section>
    <div mat-dialog-title>
      <div class="d-flex justify-content-between">
        <p>Add Impact</p>
        <i id="ibtClose" class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
      </div>
    </div>
  
    <div class="row">
      <div class="col-12 mt-3">
        <dynamic-form #docSetForm [repeatCount]=3>
        </dynamic-form>
      </div>
    </div>
  
    <div class="row d-flex justify-content-between p-10">
      <span>Note: Impacts will be reflected on comments only after Partial Save.</span>
      <button id="postBtnId" class="btn btn-primary" (click)="postImpactDetails()">Post</button> 
    </div>
  </section>
  